const icon = require('vue-svgicon');
icon.register({
    'estate-type-store-house': {
        width: 10,
        height: 10,
        viewBox: '0 0 10 10',
        data: `<path pid="0" d="M4.966.548a.297.297 0 00-.105.034L.713 2.754a.303.303 0 00-.157.262V9.14c0 .155.14.296.296.296h8.296a.308.308 0 00.296-.296V3.016a.303.303 0 00-.157-.262L5.139.582a.299.299 0 00-.173-.034zM5 1.18l3.852 2.015v5.647H7.37V4.596a.308.308 0 00-.296-.296H2.895a.307.307 0 00-.265.296v4.246H1.148V3.195L5 1.18zm-.821 1.738a.308.308 0 00-.28.311.308.308 0 00.31.281H5.79c.157.002.3-.14.3-.296a.308.308 0 00-.3-.296H4.18zm-.957 1.975h3.556v.592H3.222v-.592zm0 1.185h3.556v.493H3.222v-.493zm0 1.086h3.556v.494H3.222v-.494zm0 1.086h3.556v.592H3.222V8.25z" _fill="#C70E00"/>`,
    },
});
